import { SurveyPDF } from "survey-pdf";
import { SurveyService } from './SurveyService';
import { PLATFORM_VERSION } from '@/shared/constants';
import { traverseObject } from '@/shared/parse';

export class PdfService {

  private static generate(platformVersion: PLATFORM_VERSION, template: any, results: any) {
    template = JSON.parse(JSON.stringify(template));

    if (platformVersion === PLATFORM_VERSION.V2) {

      traverseObject(template, obj => {
        if (obj.name) {
          if (obj.description) {
            obj.description = '';
          }
          if (obj.html) {
            obj.html = '';
          }
        }
      });

    }

    const firstPageName = template.pages[0].name;
    if (firstPageName === 'Introduction')
      template.pages.shift();
    
    let pdfWidth = template.pdfWidth ?? 210;
    let pdfHeight = template.pdfHeight ?? 297;
    
    let options: any = {
        fontSize: 11,
        orientation: platformVersion === PLATFORM_VERSION.V2 ? "0" : "l",
        matrixRenderAs: "auto",
        margins: {
            left: 10,
            right: 10,
            top: 10,
            bot: 10
        },
        haveCommercialLicense: true,
        format: [pdfWidth, pdfHeight]
    };
    const surveyPDF = new SurveyPDF(template, options);
    surveyPDF.mode = 'display';
    surveyPDF.onTextMarkdown.add((_, options) => {
      options.html = SurveyService.processMarkdown(options.text)
    });

    if (results) {
        surveyPDF.data = results;
    }

    return surveyPDF;
  }

  public static async generateSurveyPdf(platformVersion: PLATFORM_VERSION, json: any, data: any) {
    const surveyPDF = this.generate(platformVersion, json, data);
    const blob: Blob = await surveyPDF.raw('blob') as any;
    return blob;
  }

}